import { deriveAgentStatus } from '../../../common/package/seat';
import { AGENT_STATUS } from '../../../core/constants/domain';

export const STATUS_SEQUENCE = [
    AGENT_STATUS.RUNNING,
    AGENT_STATUS.CONNECTED,
    AGENT_STATUS.WAITING,
    AGENT_STATUS.BLOCKED,
    AGENT_STATUS.OFFLINE,
];

export const CONTROL = Object.freeze({ PAUSED: 'pausado', ENABLED: 'habilitado' });

// Core has no team→agent link. A position belongs to a person; a team owns
// that person's positions through its active memberships.
export function agentsOfTeam(seats, members, overrides = new Map()) {
    const userIds = new Set(members.map((member) => member.userId));
    return seats
        .filter((seat) => userIds.has(seat.userId))
        .map((seat) => toAgent(seat, overrides));
}

export function toAgent(seat, overrides = new Map()) {
    const simulated = overrides.get(seat.id) ?? null;
    const effective = simulated ? { ...seat, controlState: simulated } : seat;
    return {
        seat: effective,
        realControlState: seat.controlState,
        simulatedControl: simulated,
        status: deriveAgentStatus(effective),
    };
}

export function countByStatus(agents) {
    const counts = Object.fromEntries(STATUS_SEQUENCE.map((status) => [status, 0]));
    for (const agent of agents) counts[agent.status] += 1;
    return counts;
}

export function nextSimulatedControl(agent) {
    return agent.seat.controlState === CONTROL.PAUSED ? CONTROL.ENABLED : CONTROL.PAUSED;
}
